import { gql } from '@apollo/client';

const GENERATE_HOLTER_REPORT_COMMENTS = gql`
  mutation generateHolterReportComments($input: GenerateHolterReportCommentsInput!) {
    generateHolterReportComments(input: $input) {
      isSuccess
      message
      processingStudyFids
      isReady
      simultaneousStudyLimit
    }
  }
`;

export default GENERATE_HOLTER_REPORT_COMMENTS;
